/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function createNote(params) {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes`, {
    method: "POST",
    data: params,
  });

  return (await result).data;
}

export async function getAllNotes({ page = 1, pageSize = 10, id, sorting, category }) {
  page--;

  const SkipCount = page * pageSize;

  const params = {
    SkipCount,
    MaxResultCount: pageSize,
    EntityId: id,
    Sorting: sorting,
    Category: category,
  };

  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes`, {
    params,
  });

  return (await result).data;
}

export async function getCategories(id) {
  const params = {
    EntityId: id,
  };

  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes/categories`, {
    params,
  });

  return (await result).data;
}

export async function getCategoriesByType(type) {
  const params = {
    Type: type,
  };

  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes/categories-by-type`, {
    params,
  });

  return (await result).data;
}

export async function deleteNote(params) {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes/${params}`, {
    method: "DELETE",
  });

  return (await result).data;
}

export async function editNote(params) {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes/${params.id}`, {
    method: "PUT",
    data: params,
  });

  return (await result).data;
}

export async function getNotesCount(referenceId) {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes/count/${referenceId}`, {
    method: "GET",
  });

  return (await result).data;
}

export async function pinNote(noteId) {
  const config = {
    method: "PATCH",
    data: {},
  };

  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/note-service/notes/toggle-pinned/${noteId}`, config);

  return (await result).data;
}
